import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import CrmEnrichmentJobTypeButton from "../../../components/wizard/CrmEnrichmentJobTypeButton";
import CrmEnrichmentJobWizardHeader from "../../../components/wizard/CrmEnrichmentJobWizardHeader";
import { CRM_ENRICHMENT_CONTENT_ID } from "../../../constants";
import type { CrmEnrichmentJobType, CrmProvider } from "../../../types/types";
import createCrmEnrichmentI18nKeys from "../../../utils/translations";

import { JOB_TYPE_CONFIG } from "./const";
import {
    StyledCrmEnrichmentJobTypeBulletList,
    StyledCrmEnrichmentJobTypeBulletListItem,
    StyledCrmEnrichmentJobTypeSubtitle,
    StyledCrmEnrichmentJobTypeButtonsWrapper,
} from "./styles";

type Props = {
    crmProvider: CrmProvider;
    selectedJobType: CrmEnrichmentJobType | "";
    onSelectedJobType: (type: CrmEnrichmentJobType) => void;
};

const CrmEnrichmentJobTypeWizardStep = ({ crmProvider, selectedJobType, onSelectedJobType }: Props) => {
    const contentId = CRM_ENRICHMENT_CONTENT_ID[crmProvider];

    const bulletPointsList = [
        `si.crm-enrichment.${contentId}.job-wizard.type.bullet1`,
        `si.crm-enrichment.${contentId}.job-wizard.type.bullet2`,
        `si.crm-enrichment.${contentId}.job-wizard.type.bullet3`,
    ];

    const i18nKeys = createCrmEnrichmentI18nKeys(crmProvider);

    return (
        <>
            <CrmEnrichmentJobWizardHeader
                titleKey={`si.crm-enrichment.${contentId}.job-wizard.type.title`}
                descriptionKey={`si.crm-enrichment.${contentId}.job-wizard.type.description`}
            />

            <StyledCrmEnrichmentJobTypeBulletList>
                {bulletPointsList.map((key) => (
                    <I18n
                        key={key}
                        translatable={{ key }}
                        element={StyledCrmEnrichmentJobTypeBulletListItem}
                    />
                ))}
            </StyledCrmEnrichmentJobTypeBulletList>

            <I18n
                translatable={{
                    key: `si.crm-enrichment.job-wizard.type.subtitle`,
                }}
                element={StyledCrmEnrichmentJobTypeSubtitle}
            />

            <StyledCrmEnrichmentJobTypeButtonsWrapper>
                {JOB_TYPE_CONFIG.map(({ type, iconName }) => (
                    <CrmEnrichmentJobTypeButton
                        type={type}
                        isSelected={selectedJobType === type}
                        title={i18nKeys.type(type)}
                        description={`si.crm-enrichment.job-wizard.type.${type}.description`}
                        iconName={iconName(crmProvider)}
                        onClick={onSelectedJobType}
                    />
                ))}
            </StyledCrmEnrichmentJobTypeButtonsWrapper>
        </>
    );
};

export default CrmEnrichmentJobTypeWizardStep;
